'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/layout/buy-modal.hbs');

var BuyModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        actionBuy: '[data-action="buy"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.actionBuy': 'actionBuy',
    },

    actionClose: function(event) {
        this.trigger('close:modal', 'dashboard');
    },

    actionBuy: function(event) {
        var shop = this.getOption('shop');
        console.log('Shopped:', shop, this.model);
        var offer = new shop.offers.model(null, {collection: shop.offers});

        var data = {
            objectId: this.model.id,
            shopType: shop.id,
            buyerId: App.user.id,
        };

        offer.save(data, {
            success: function(model, response, options) {
                shop.offers.add(model);
                console.log(model);
                // this.trigger('close:modal');
                App.router.navigate('/community/groups/conversation/' + model.get('conversationId'), {trigger: true});
            }.bind(this),
            error: function(model, response, options) {
                console.log('error creating offer');
                //@todo
                // Messenger().post({
                //     type: 'error',
                //     message: App.t('collection::create:response:error:create'),
                //     actions: {
                //         'try-again': {
                //             label: App.t('global::messenger:button:try-again'),
                //             action: function() {
                //                 errorMessage.hide();
                //                 this.ui.form.submit();
                //             }.bind(this),
                //         },
                //         'cancel': {
                //             label: App.t('global::messenger:button:cancel'),
                //             action: function() {
                //                 errorMessage.hide();
                //             }.bind(this),
                //         },
                //     },
                // });
            },
        });
    },
});

module.exports = BuyModalView;